import { Flex } from '@chakra-ui/react';
import { OktonAppShell, OktonNavSection } from '@okton/platform-ui';
import React, { useMemo } from 'react';
import { LuChartBarBig } from 'react-icons/lu';
import { KeyRound, NetworkIcon, PackageIcon, Settings } from 'lucide-react';
import { useHistory, useLocation } from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import { usePermissoes } from '../services/hooks/usePermissoes';

interface IIntegraAppPage {
  children?: React.ReactNode;
}

const IntegraAppPage: React.FC<IIntegraAppPage> = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const { signOut } = useAuth();
  const { permite, Permissoes } = usePermissoes();

  const menu = useMemo<OktonNavSection[]>(() => {
    const geral = [
      permite(Permissoes.DASHBOARD_VIEW)
        ? {
            id: 'dashboard',
            label: 'Dashboard',
            href: '/dashboard',
            icon: LuChartBarBig,
            exact: true,
          }
        : null,
      permite(Permissoes.PRODUTOS_VIEW)
        ? {
            id: 'produtos',
            label: 'Produtos',
            href: '/produtos',
            icon: PackageIcon,
            exact: true,
          }
        : null,
      permite(Permissoes.PEDIDOS_VIEW)
        ? {
            id: 'pedidos',
            label: 'Pedidos',
            href: '/pedidos',
            icon: NetworkIcon,
            exact: true,
          }
        : null,
    ].filter(Boolean) as OktonNavSection['items'];

    const configuracoes = [
      permite(Permissoes.API_TOKENS_MANAGE)
        ? {
            id: 'canais',
            label: 'Canais',
            href: '/canais',
            icon: NetworkIcon,
            exact: true,
          }
        : null,
      permite(Permissoes.API_TOKENS_MANAGE)
        ? {
            id: 'api',
            label: 'Gerenciar API',
            href: '/tokens/integra',
            icon: KeyRound,
            exact: true,
          }
        : null,
      permite(Permissoes.EMPRESA_ADMIN)
        ? {
            id: 'empresa-admin',
            label: 'Empresa Admin',
            href: '/admin-empresa',
            icon: Settings,
            exact: true,
          }
        : null,
    ].filter(Boolean) as OktonNavSection['items'];

    return [
      ...(geral.length ? [{ id: 'geral', title: 'GERAL', items: geral }] : []),
      ...(configuracoes.length
        ? [
            {
              id: 'configuracoes',
              title: 'CONFIGURAÇÕES',
              items: configuracoes,
            },
          ]
        : []),
    ];
  }, [permite, Permissoes]);

  return (
    <OktonAppShell
      menu={menu}
      onLogout={signOut}
      pathname={location.pathname}
      onNavigate={href => history.push(href)}
    >
      <Flex w="100%" h="100%" px="6" flexDir="column" pt="16">
        {children}
      </Flex>
    </OktonAppShell>
  );
};

export default IntegraAppPage;
